/**
 * Filtros do painel da fila do comprador (função pura, testável).
 * Os funis das colunas da tabela refinam DEPOIS destes.
 */

const DIA_MS = 86400000;

export function passaNosFiltrosDaFila(r, filtros, agora = new Date()) {
  if (!filtros.incluirCanceladas && r.situacao === "CANCELADA" && filtros.situacao !== "CANCELADA") return false;
  if (filtros.situacao === "AGUARDANDO_APROVACAO") {
    if (!["RASCUNHO", "EM_COTACAO"].includes(r.situacao)) return false;
  } else if (filtros.situacao && r.situacao !== filtros.situacao) return false;
  if (filtros.origem?.length && !filtros.origem.includes(r.origem)) return false;
  // ADR-0078: "de terceiros" olha os ITENS — a requisição manual com um
  // espelho dentro também é de terceiros.
  if (filtros.soTerceiros && !r.tem_terceiro) return false;
  if (filtros.tipoTerceiro?.length
    && !(r.tipos_terceiro || []).some((t) => filtros.tipoTerceiro.includes(t))) return false;
  if (filtros.comprador?.length) {
    const semResp = filtros.comprador.includes("nenhum") && !r.comprador;
    if (!semResp && !filtros.comprador.includes(r.comprador)) return false;
  }
  if (filtros.solicitante?.length && !filtros.solicitante.includes(r.solicitado_por)) return false;
  if (filtros.prioridade && r.prioridade !== filtros.prioridade) return false;
  if (filtros.soAtrasadas && !r.atrasada) return false;
  if (filtros.semAnexo && !(r.itens_sem_anexo > 0)) return false;
  if (filtros.prazoAte && r.prazo_cotacao && r.prazo_cotacao > filtros.prazoAte) return false;
  if (filtros.criadaEm) {
    const limite = new Date(agora.getTime() - Number(filtros.criadaEm) * DIA_MS);
    if (new Date(r.created_at) < limite) return false;
  }
  // Período exato, no DIA LOCAL de quem olha (a data vem em UTC).
  if (filtros.criadaDe || filtros.criadaAte) {
    const d = new Date(r.created_at);
    const dia = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
    if (filtros.criadaDe && dia < filtros.criadaDe) return false;
    if (filtros.criadaAte && dia > filtros.criadaAte) return false;
  }
  return true;
}
